import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PageHeader, Section } from "@/components/common/kit";
import RemoteTable from "@/components/common/RemoteTable";
import { DateRangeFilter, useRange } from "@/components/common/Filters";
import { fmtDT } from "@/lib/format";

const TYPES = ["product", "salesman", "stock_issue", "stock_transfer", "stock_return", "stock_adjustment", "daily_closure", "daily_opening_stock", "expense", "receivable_settlement", "settings", "user"];

export default function AuditLogs() {
  const [q, setQ] = useState("");
  const [type, setType] = useState("all");
  const [range, setRange] = useRange("month");
  const [view, setView] = useState(null);
  const cols = [
    { key: "created_at", label: "Date / Time", type: "datetime" }, { key: "username", label: "User" }, { key: "role", label: "Role" },
    { key: "action", label: "Action" }, { key: "record_type", label: "Record" }, { key: "message", label: "Description", render: (r) => <span className="whitespace-normal">{r.message}</span> },
    { key: "d", label: "", sortable: false, noExport: true, render: (r) => (r.previous_value || r.new_value) && <Button size="sm" variant="ghost" onClick={() => setView(r)} data-testid={`audit-view-${r.id}`}>Values</Button> },
  ];
  return (
    <div className="space-y-6">
      <PageHeader title="Audit Logs" subtitle="Immutable trail of every important action. Read-only." />
      <div className="flex flex-wrap gap-2">
        <Input placeholder="Search description or user…" value={q} onChange={(e) => setQ(e.target.value)} className="h-9 w-64" data-testid="audit-search" />
        <Select value={type} onValueChange={setType}>
          <SelectTrigger className="h-9 w-52" data-testid="audit-type-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All record types</SelectItem>{TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
        </Select>
        <DateRangeFilter value={range} onChange={setRange} />
      </div>
      <Section>
        <RemoteTable url="/audit-logs" pageSize={50} params={{ q: q || undefined, record_type: type === "all" ? undefined : type, date_from: range.from, date_to: range.to }}
          columns={cols} searchable={false} title="Audit Log" exportable testid="audit-table" />
      </Section>
      <Dialog open={!!view} onOpenChange={(o) => !o && setView(null)}>
        <DialogContent className="max-w-3xl" data-testid="audit-values-dialog">
          <DialogHeader><DialogTitle>{view?.action} · {fmtDT(view?.created_at)}</DialogTitle></DialogHeader>
          <div className="grid gap-3 md:grid-cols-2">
            {[["Previous value", view?.previous_value], ["New value", view?.new_value]].map(([l, v]) => (
              <div key={l}><p className="mb-1 text-xs font-semibold uppercase text-slate-500">{l}</p>
                <pre className="max-h-96 overflow-auto rounded bg-slate-900 p-3 font-mono text-[11px] text-slate-100">{v ? JSON.stringify(v, null, 2) : "—"}</pre></div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
